import Navbar from "./LandingPageScreens/Navbar";
import PenEEG from "../assets/img/230615-PenEEG.757.png";
import HandPen from "../assets/img/new-home-page/hand-pen.png";
import Signals from "../assets/img/new-home-page/singals_bg.png";
import Footer from "../components/Footer";
import FeatureShowcase from "./LandingPageScreens/FeatureShow";
import GridLayout from "./LandingPageScreens/GridLayout";
import ScrollSlideshow from "./LandingPageScreens/ScrollSlideshow";
import OurPartners from "./LandingPageScreens/OurPartners";

function LandingPage() {
  return (
    <>
      <main>
        <Navbar />
        <section className="tw-relative tw-w-full tw-flex tw-items-center tw-justify-between animated-gradient tw-px-6 md:tw-px-20 tw-py-16 lg:tw-py-24 tw-overflow-visible">
          {/* Text Content */}
          <div className="tw-z-10 tw-w-full md:tw-w-1/2 tw-py-5">
            <p className="tw-text-3xl sm:tw-text-4xl md:tw-text-6xl tw-font-extrabold tw-text-white tw-font-sans tw-leading-tight tw-mb-1">
              MODERNIZE
            </p>
            <p className="tw-text-3xl sm:tw-text-4xl md:tw-text-6xl tw-text-white tw-font-sans tw-leading-tight tw-mb-1">
              BRAIN HEALTH
            </p>
            <p className="tw-text-3xl sm:tw-text-4xl md:tw-text-6xl tw-text-white tw-font-sans tw-leading-tight">
              SCREENING
            </p>
            <p className="tw-text-base sm:tw-text-lg md:tw-text-xl tw-text-green-900 tw-max-w-md tw-mt-4">
              From the intensive care unit to the sidelines, the{" "}
              <span className="tw-font-semibold">CenSyn platform</span> is the{" "}
              <span className="tw-font-semibold">
                next-generation 2 minute solution
              </span>{" "}
              to brain health screening.
            </p>
          </div>

          {/* Fixed-size Floating Image */}
          <div className="tw-relative tw-w-0 tw-h-0 sm:tw-w-auto sm:tw-h-auto">
            <img
              src={PenEEG}
              alt="Pen EEG device"
              className="
        tw-hidden sm:tw-block
        tw-absolute
        tw-w-[800px]  lg:tw-w-[1200px] 
        tw-top-[-200px]    lg:tw-top-[-300px] 
       xl:tw-right-[-200px]  lg:tw-right-[-400px] md:tw-right-[-300px]
        tw-z-0
      "
            />
          </div>
        </section>

        {/* {second section} */}
        <section className="tw-relative tw-mt-4 sm:tw-mt-10 md:tw-mt-20 tw-px-4 md:tw-px-20">
          <div className="tw-flex tw-flex-col tw-items-start">
            <div>
              <p className="tw-text-3xl sm:tw-text-4xl md:tw-text-6xl tw-font-extrabold tw-font-sans tw-bg-gradient-to-r tw-from-blue-300 tw-to-green-300 tw-text-transparent tw-bg-clip-text">
                Here's how it works
              </p>
              <p className="tw-text-base sm:tw-text-lg md:tw-text-2xl tw-max-w-lg tw-text-gray-800 tw-mt-2">
                CenSyn's <span className="tw-font-semibold">PenEEG™</span> and
                proprietary software enables long-term brain health management.
              </p>
            </div>
          </div>
        </section>
        <section>
          <ScrollSlideshow />
        </section>

        <section className="tw-relative tw-px-4 sm:tw-px-6 md:tw-px-20 tw-py-10">
          <div className="tw-flex tw-flex-col tw-items-start">
            <div>
              <p className="tw-text-2xl sm:tw-text-3xl md:tw-text-5xl tw-font-extrabold tw-font-sans tw-bg-gradient-to-r tw-from-blue-300 tw-to-green-300 tw-text-transparent tw-bg-clip-text">
                Brain Health: End to End.
              </p>
              <p className="tw-text-base sm:tw-text-lg md:tw-text-2xl tw-max-w-md sm:tw-max-w-lg tw-text-gray-800 tw-mt-2">
                Hardware, software and interactive modules to give you the most
                insights into brain health.
              </p>
            </div>
          </div>
        </section>

        <section className="md:tw-mt-10">
          <FeatureShowcase />
        </section>

        <section className="tw-relative tw-mt-10 sm:tw-mt-15 md:tw-mt-20 tw-w-full tw-h-[250px] md:tw-h-[250px] tw-flex tw-items-center tw-justify-between tw-bg-gradient-to-r tw-from-blue-300 tw-to-green-100 tw-px-4 sm:tw-px-6 md:tw-px-20 tw-py-10">
          <div className="tw-flex tw-justify-center tw-items-center tw-absolute tw-inset-y-0 tw-left-0 tw-w-[74%] md:tw-w-[74%] tw-z-0">
            <img
              src={Signals}
              className="tw-w-full tw-object-cover"
              alt="EEG signal background"
            />
          </div>
          <div className="tw-relative tw-z-10 tw-flex-1">
            <p className="tw-text-5xl sm:tw-text-6xl md:tw-text-8xl tw-font-sans tw-text-white">
              PenEEG
            </p>
            <p className="tw-text-3xl md:tw-text-4xl tw-max-w-lg tw-text-white">
              Screening use cases
            </p>
          </div>
          <img
            src={HandPen}
            className="tw-absolute tw-right-0 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-w-[42%] min-w-[150px] sm:min-w-[200px] tw-max-h-[400px] tw-object-contain tw-z-10"
            alt="Hand holding pen device"
          />
        </section>

        <section className="tw-mt-[5%] tw-mb-[5%]">
          <GridLayout />
        </section>
        <OurPartners />
      </main>

      <div id="layoutDefault_footer">
        <Footer />
      </div>
    </>
  );
}

export default LandingPage;
